var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',_vm._g(_vm._b({class:'base-button-' + _vm.variant,attrs:{"size":_vm.elSize,"type":_vm.variant,"disabled":_vm.disabled}},'Button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }